import { Chart, PointElement, } from 'chart.js';
import { merge } from 'chart.js/helpers';
import { GeoFeature } from '../elements';
import { ProjectionScale, SizeScale } from '../scales';
import { GeoController, geoDefaults, geoOverrides } from './GeoController';
import patchController from './patchController';
export class BubbleMapController extends GeoController {
    initialize() {
        super.initialize();
        this.enableOptionSharing = true;
    }
    linkScales() {
        super.linkScales();
        const dataset = this.getGeoDataset();
        const meta = this.getMeta();
        meta.vAxisID = 'size';
        meta.rAxisID = 'size';
        dataset.vAxisID = 'size';
        dataset.rAxisID = 'size';
        meta.rScale = this.getScaleForId('size');
        meta.vScale = meta.rScale;
        meta.iScale = meta.xScale;
        meta.iAxisID = meta.xAxisID;
        dataset.iAxisID = meta.xAxisID;
    }
    _getOtherScale(scale) {
        return scale;
    }
    parse(start, count) {
        const rScale = this.getMeta().rScale;
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        for (let i = start; i < start + count; i += 1) {
            const d = data[i];
            meta._parsed[i] = {
                x: d.longitude == null ? d.x : d.longitude,
                y: d.latitude == null ? d.y : d.latitude,
                [rScale.axis]: rScale.parse(d, i),
            };
        }
    }
    updateElements(elems, start, count, mode) {
        const reset = mode === 'reset';
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const scale = this.getProjectionScale();
        this.getMeta().rScale._model = firstOpts;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        for (let i = start; i < start + count; i += 1) {
            const elem = elems[i];
            const parsed = this.getParsed(i);
            const projection = scale.projection([parsed.x, parsed.y]);
            const properties = {
                x: projection ? projection[0] : 0,
                y: projection ? projection[1] : 0,
                skip: Number.isNaN(parsed.x) || Number.isNaN(parsed.y),
            };
            if (includeOptions) {
                properties.options = (sharedOptions || this.resolveDataElementOptions(i, mode));
                if (reset) {
                    properties.options.radius = 0;
                }
            }
            this.updateElement(elem, i, properties, mode);
        }
    }
    indexToRadius(index) {
        const rScale = this.getMeta().rScale;
        return rScale.getSizeForValue(this.getParsed(index)[rScale.axis]);
    }
}
BubbleMapController.id = 'bubbleMap';
BubbleMapController.defaults = merge({}, [
    geoDefaults,
    {
        dataElementType: PointElement.id,
        datasetElementType: GeoFeature.id,
        showOutline: true,
        clipMap: 'outline+graticule',
    },
]);
BubbleMapController.overrides = merge({}, [
    geoOverrides,
    {
        plugins: {
            tooltip: {
                callbacks: {
                    title() {
                        return '';
                    },
                    label(item) {
                        var _a, _b, _c, _d;
                        if (item.formattedValue == null) {
                            return (_b = (_a = item.chart.data) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b[item.dataIndex];
                        }
                        return `${(_d = (_c = item.chart.data) === null || _c === void 0 ? void 0 : _c.labels) === null || _d === void 0 ? void 0 : _d[item.dataIndex]}: ${item.formattedValue}`;
                    },
                },
            },
        },
        scales: {
            size: {
                axis: 'x',
                type: SizeScale.id,
            },
        },
        elements: {
            point: {
                radius(context) {
                    if (context.dataIndex == null) {
                        return null;
                    }
                    const controller = context.chart.getDatasetMeta(context.datasetIndex)
                        .controller;
                    return controller.indexToRadius(context.dataIndex);
                },
                hoverRadius(context) {
                    if (context.dataIndex == null) {
                        return null;
                    }
                    const controller = context.chart.getDatasetMeta(context.datasetIndex)
                        .controller;
                    return controller.indexToRadius(context.dataIndex) + 1;
                },
            },
        },
    },
]);
export class BubbleMapChart extends Chart {
    constructor(item, config) {
        super(item, patchController('bubbleMap', config, BubbleMapController, GeoFeature, [SizeScale, ProjectionScale]));
    }
}
BubbleMapChart.id = BubbleMapController.id;
//# sourceMappingURL=BubbleMapController.js.map